<template>
    <div
        class="d-flex flex-column align-items-center"
        style="
            background-color: var(--neutral-450);
            border-radius: var(--radius-default);
        "
    >
        <button
            type="button"
            :disabled="disabled"
            @click="toggleTimer($event)"
            class="btn w-100"
            :class="isRunning ? 'btn-success' : 'btn-secondary'"
            style="border-bottom-left-radius: 0; border-bottom-right-radius: 0"
        >
            {{ isRunning ? 'Stop Timer' : 'Start Timer' }}
        </button>
        <div
            class="d-flex w-100 align-items-center justify-content-between gap-2 ps-2"
        >
            <span class="font-monospace d-flex align-items-center gap-2">
                <i class="fi fi-clock"></i>
                {{ formattedTime }}
            </span>
            <button
                type="button"
                :disabled="disabled"
                title="Reset Timer"
                @click="resetTimer($event)"
                class="btn icon-btn icon-btn-light reset-btn"
            >
                <i class="fi fi-reset-timer"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Timer',
    props: {
        modelValue: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            seconds: this.modelValue,
            isRunning: false,
            intervalId: null,
        };
    },
    computed: {
        formattedTime() {
            const minutes = String(Math.floor(this.seconds / 60)).padStart(
                2,
                '0'
            );
            const secs = String(this.seconds % 60).padStart(2, '0');
            return `${minutes}:${secs}`;
        },
    },
    watch: {
        modelValue(newVal) {
            if (typeof newVal === 'number' && newVal >= 0) {
                this.seconds = newVal;
            }
        },
        seconds(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    methods: {
        toggleTimer(event) {
            event.stopPropagation();
            if (this.isRunning) {
                clearInterval(this.intervalId);
                this.intervalId = null;
                this.isRunning = false;
                this.$emit('timer-stopped');
            } else {
                this.isRunning = true;
                this.intervalId = setInterval(() => {
                    this.seconds++;
                }, 1000);
                this.$emit('timer-started');
            }
        },
        resetTimer(event) {
            event.stopPropagation();
            if (this.isRunning) {
                clearInterval(this.intervalId);
                this.intervalId = null;
                this.isRunning = false;
            }
            this.seconds = 0;
            this.$emit('timer-reset');
        },
    },
    beforeUnmount() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
};
</script>
<style scoped>
.reset-btn {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border: none !important;
}

.reset-btn:not(:hover):not(:active) {
    background-color: var(--neutral-450);
}
</style>
